/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const preOrderDateContainer = document.getElementById("release-date-onPreOrder");

const interval = setInterval(() => {
  const productList = document.querySelector('.boost-sd__product-list');
  if (productList) {
    // Stop the interval as soon as we find the target element
    setTimeout(() => clearInterval(interval), 2000)
    product_preOrder();
    document.addEventListener("click", (event) => {
      //console.log("Document click detected on");
      setTimeout(() => {
        product_preOrder();
      }, 1500);
    });
  }else{
    setTimeout(() => clearInterval(interval), 50000)
  }
}, 1000);

function product_preOrder(){
  const productItems = document.querySelectorAll('.boost-sd__product-item');

  productItems.forEach((item, index) => {
    const productId = item.getAttribute('id');
    const productElement = document.querySelector(`[data-product-id="${productId}"]`);

    const tags = window.boostSDFallback?.products[index]?.tags || [];
    const isPreOrder = tags.some(tag => 
      ["Pre-Orders", "Pre-Order", "PreOrders", "PreOrder"].includes(tag)
    );

    if (productElement && isPreOrder) {
      // Update "Add to cart" button text
      const addToCartButton = productElement.querySelector(
        'button[aria-label="Add to cart"] span.boost-sd__button-text.boost-sd__cta-button-text'
      );
      if (addToCartButton) {
        addToCartButton.textContent = "Pre-order";
      }

      if(productElement.querySelector('button[aria-label="Add to cart"]')){
        productElement.querySelector('button[aria-label="Add to cart"]').addEventListener('click', (e) => {
        const intervalText = setInterval(() => {
            if(addToCartButton.textContent === "Add to cart"){
              addToCartButton.textContent = "Pre-order";
              clearInterval(intervalText);
            }
          }, 200);
        })
      }

      const quickViewButtons = productElement.querySelector('.boost-sd__button--quick-view');
     
      if(quickViewButtons){
        quickViewButtons.addEventListener("click", (e) => {
          const preOrder_date = productElement.querySelector('.product-meta-release--date span');
          //console.log("Preorder Date: ", preOrder_date.innerText)
          const pre_order__text = preOrder_date.innerText;
          quick_modalview(pre_order__text); 
        });  
      }
      
      // Process product meta and release date
      const trackedItems = preOrderDateContainer.querySelectorAll(
        "#product_lists li.prodict-list-item .product--item"
      );

      trackedItems.forEach(trackedItem => {
        const trackedProductId = parseInt(trackedItem.getAttribute("data-productid"));
        if (trackedProductId === parseInt(productId)) {
          const productMeta = trackedItem.getAttribute("data-product-meta");

          // Remove existing meta containers or ribbons if any
          productElement.querySelector(".product-meta--container")?.remove();
          productElement.querySelector(".boost-sd_ribbon")?.remove();

          if (productMeta) {
            // Insert release date layout
            const releaseDateLayout = `
              <div class="product-meta--container">
                <div class="product-meta-release--date">
                  <span>${productMeta}</span>
                </div>
              </div>`;
            productElement
              .querySelector(".boost-sd__product-title")
              .insertAdjacentHTML("beforebegin", releaseDateLayout);

            // Insert ribbon
            const ribbonTag = `
              <div class="ribbon boost-sd_ribbon ribbon-bottom-right">
                <span>pre-order</span>
              </div>`;
            productElement
              .querySelector(".boost-sd__product-link.boost-sd__product-link-image")
              .insertAdjacentHTML("beforebegin", ribbonTag);
          }
        }
      });
    }
  });
}

function quick_modalview(text){
  const intervalModal = setInterval(() => {
   const modalContainer = document.getElementById("boost-sd__modal-quickview");
   if(modalContainer){
     //console.log("quick-button", modalContainer boost-sd__quick-view-btn);
     // Check if the layout already exists
      if (!modalContainer.querySelector(".product-meta--container")) {
        const preorderDateLayout = `
          <div class="product-meta--container">
            <div class="product-meta-release--date">
              <span>${text}</span>
            </div>
          </div>`;
        modalContainer
          .querySelector(".boost-sd__quick-view-btn")
          .insertAdjacentHTML("beforebegin", preorderDateLayout);
      }
   
     const modal_addtoCart = modalContainer.querySelector(".boost-sd__btn-add-to-cart");
     if (modal_addtoCart) {
        modal_addtoCart.textContent = "Pre-order";
      }
     clearInterval(intervalModal);
   }
  },500)
}

